export default __webpack_public_path__ + "static/media/Q5_1_resized.a43cec38.jpg";